import Upper from "./features/Upper";
import { useEffect, useState } from "react";
import { PcsDetailType, PcsSubjectElementType } from "../detail/interface";
import { pcsDetailInit } from "../detail/state";
import { useForm, useWatch } from "react-hook-form";
import TabNav from "./features/TabNav";
import Tab1 from "./features/Tab1";
import { useSavePurchaseOrder } from "../detail/hooks/useSavePurchaseOrder";
import { useModal } from "../../../../hooks";
import useGoToNavigation from "../../../../util/useGotoNavigation";
import { useUser } from "../../../../util/userContext/UserContext";
import Tab2 from "./features/Tab2";
import { useLocation } from "react-router-dom";
import moment from "moment";
import useSetPurchaseValue from "../detail/hooks/useSetPurchaseValue";

interface CreateSubjectType {
    list: PcsSubjectElementType[]
}

export default function PcsCreate({ isOrderRequest }: { isOrderRequest?: boolean }) {
    const { pathname } = useLocation()
    const { handleModal } = useModal();
    const { user } = useUser();
    const { goToNavigation } = useGoToNavigation();
    const { state } = useLocation()

    const [tab, setTab] = useState("tab-1");
    const [createDetail, setCreateDetail] = useState<PcsDetailType>((() => ({
        ...pcsDetailInit,
        purchaseOrderDt: moment().format("YYYY-MM-DD")
    }))())
    const [createSubject, setCreateSubject] = useState<CreateSubjectType>({ list: [] })

    const { mutateAsync: mutateAsyncSavePurchaseOrder } = useSavePurchaseOrder()

    const { register, getValues, setValue, control, handleSubmit, watch } = useForm({
        defaultValues: createDetail
    })
    const {
        register: registerSubject,
        getValues: getValuesSubject,
        setValue: setValueSubject,
        control: controlSubject,
        handleSubmit: handleSubmitSubject,
        watch: watchSubject
    } = useForm({
        defaultValues: createSubject,
    })

    const watchCreateDetail = {
        ...createDetail,
        ...useWatch<PcsDetailType>({ control }),
    } as PcsDetailType

    const watchCreateSubject = {
        ...createSubject,
        ...useWatch<CreateSubjectType>({ control: controlSubject }),
    } as CreateSubjectType

    const btnSave = () => {
        if (!watchCreateDetail.newLEnduserValue || watchCreateDetail.newLEnduserValue === "") {
            handleModal({
                isOpen: true,
                contents: "회사 정보가 없습니다.",
                type: "alert",
            })
        } else if (!watchCreateDetail.newLContactValue || watchCreateDetail.newLContactValue === "") {
            handleModal({
                isOpen: true,
                contents: "고객 정보가 없습니다.",
                type: "alert",
            })
        } else if (!watchCreateDetail.purchaseOrderDt || watchCreateDetail.purchaseOrderDt === "") {
            handleModal({
                isOpen: true,
                contents: `${menuTitleText()}일자를 입력해주세요.`,
                type: "alert",
            })
        } else if (!watchCreateDetail.newDtRequestShipment || watchCreateDetail.newDtRequestShipment === "") {
            handleModal({
                isOpen: true,
                contents: "납품희망일을 입력해주세요.",
                type: "alert",
            })
        } else if (!watchCreateDetail.newPShipment || watchCreateDetail.newPShipment === 0) {
            handleModal({
                isOpen: true,
                contents: "배송방법을 선택해주세요.",
                type: "alert",
            })
        } else if (!watchCreateDetail.newLRecipientValue || watchCreateDetail.newLRecipientValue === "") {
            handleModal({
                isOpen: true,
                contents: "수신자를 선택해주세요.",
                type: "alert",
            })
        }
        // else if (!watchCreateDetail.newLAddressValue || watchCreateDetail.newLAddressValue === "") {
        //     handleModal({
        //         isOpen: true,
        //         contents: "발송지를 선택해주세요.",
        //         type: "alert",
        //     })
        // }
        // else if (!watchCreateDetail.newDtEstimatedCollection || watchCreateDetail.newDtEstimatedCollection === "") {
        //     handleModal({
        //         isOpen: true,
        //         contents: "수금예정일을 입력해주세요.",
        //         type: "alert",
        //     })
        // }
        // else if (!watchCreateDetail.newPPayment || watchCreateDetail.newPPayment === 0) {
        //     handleModal({
        //         isOpen: true,
        //         contents: "결제방법을 선택해주세요.",
        //         type: "alert",
        //     })
        // }
        else if (!watchCreateDetail.newLInvoiceAgentValue || watchCreateDetail.newLInvoiceAgentValue === "") {
            handleModal({
                isOpen: true,
                contents: "계산서 담당자를 선택해주세요.",
                type: "alert",
            })
        } else if (watchCreateSubject.list.length === 0) {
            handleModal({
                isOpen: true,
                contents: "발주 품목을 추가해주세요.",
                type: "alert",
            })
        } else if (watchCreateSubject.list.some(el => el.newLErpProductValue === "")) {
            handleModal({
                isOpen: true,
                contents: "발주 품목을 선택해주세요.",
                type: "alert",
            })
        } else {
            console.log("저장 : ", {
                ...watchCreateDetail, subjectList: watchCreateSubject.list?.map((el, idx) => ({
                    ...el,
                    productGroupName: el.productRange,
                    //newProductGroupid: el.newProductGroupid  // 내부수정
                }))
            });
            mutateAsyncSavePurchaseOrder({
                ...watchCreateDetail,
                purchaseOrderer: user?.userId ?? 0,
                subjectList: watchCreateSubject.list?.map((el, idx) => ({
                    ...el,
                    productGroupName: el.productRange,
                    //newProductGroupid: el.newProductGroupid  // 내부수정
                })),
                purchaseOrderDt: moment(watchCreateDetail.purchaseOrderDt).format("YYYY-MM-DD"),
                newDtRequestShipment: moment(watchCreateDetail.newDtRequestShipment).format("YYYY-MM-DD"),
                newDtEstimatedCollection: moment(watchCreateDetail.newDtEstimatedCollection).isValid()
                    ? moment(watchCreateDetail.newDtEstimatedCollection).format("YYYY-MM-DD")
                    : '',
            }).then(res => {
                if (res.data.code === "0000") {
                    const purchaseOrderId = res.data.result?.purchaseOrderId ?? 0

                    handleModal({
                        isOpen: true,
                        contents: "저장되었습니다.",
                        type: "alert",
                        closeAction: () =>
                            goToNavigation(`${urlText()}/detail/${purchaseOrderId}`, {}, false)
                    });
                } else {
                    handleModal({
                        isOpen: true,
                        contents: res.data.msg,
                        type: "alert",
                    });
                }
            })
        }
    };

    // NOTE: 납품 없음
    const menuTitleText = () => {
        return isOrderRequest ? "수주 요청 " : "발주 "
    }

    // NOTE: 납품 없음
    const urlText = () => {
        return isOrderRequest ? "order/orderRequest" : "purchase/pcs"
    }

    // useEffect(() => {
    //     if (state && state.isFromExternalProduct) {
    //         const detail: PcsDetailType = state.purchaseDetail
    //
    //         setValue("purchaseOrderDt", moment().format("YYYY-MM-DD"))
    //         setValue("newDtRequestShipment", moment(detail.newDtRequestShipment).format("YYYY-MM-DD"))
    //         setValue("newPShipment", detail.newPShipment)
    //         setValue("purchaseOrderState", detail.purchaseOrderState)
    //
    //         if (detail.newLAddressValue === "" || detail.newLAddressValue === "-1") {
    //             setValue("newLAddressValue", "")
    //             setValue("customPostcode", detail.postCode)
    //             setValue("customAddress1", detail.address1)
    //             setValue("customAddress2", detail.address2)
    //         }
    //
    //     }
    // }, [state]);

    const { setPurchaseInit } = useSetPurchaseValue()
    useEffect(() => {
        if (pathname.includes("purchase/pcs") && user) {
            setPurchaseInit(setValue)

            if (state && state.isFromExternalProduct) {
                const subject: { list: PcsSubjectElementType[] } = state.purchaseSubject

                setValueSubject("list", subject.list)
                console.log("subject : ", subject);
            }
        }
    }, [pathname, user, state]);

    return <>
        <Upper watchCreateDetail={watchCreateDetail}
            register={register}
            btnSave={btnSave}
            menuTitleText={menuTitleText()}
            urlText={urlText()}
            isOrderRequest={isOrderRequest} />

        <TabNav tab={tab}
            setTab={setTab}
            menuTitleText={menuTitleText()} />

        {tab === "tab-1"
            ? <Tab1 watchCreateDetail={watchCreateDetail}
                register={register}
                setValue={setValue}
                menuTitleText={menuTitleText()}
                isOrderRequest={isOrderRequest} />
            : <Tab2 watchCreateSubject={watchCreateSubject}
                register={registerSubject}
                getValues={getValuesSubject}
                setValue={setValueSubject}
                menuTitleText={menuTitleText()}
                control={controlSubject} />
        }
    </>
}